export const itemsPerPage = 10;

export const statusFields: { [key: string]: string } = {
    draft: "Rascunho",
    approval: "Aguardando aprovação",
    display: "Em exibição",
    sold: "Vendido",
    hidden: "Escondido",
}

export const statusColors: { [key: string]: string } = {
    draft: "#000",
    approval: "#DAA53F",
    display: "#00bb00",
    sold: "#46B1F7",
    hidden: "#FF0000",
}

export const stateFields: { [key: string]: string } = {
    new: "Novo",
    // pre_owned: "Seminovo",
    used: "Usado"
}

export const movementFields: { [key: string]: string } = {
    // mec_manual: "Movimento Mecânico manual",
    // mec_auto: "Movimento Mecânico automático",
    // quartz: "Movimento de Quartzo",
    // hibrid: "Movimento Híbrido",
    // solar: "Movimento Solar",
    // high_freq: "Movimento de Alta Frequência"
    mec: "Mecânico",
    auto: "Automático",
    quartz: "Quartz",
    spring: "Spring Drive",
    other: "Outros"
}

export const braceletMaterialFields: { [key: string]: string } = {
    metal: "Metal",
    leather: "Couro",
    fabric: "Tecido",
    rubber: "Borracha",
    other: "Outros"
    // steel: "Aço Inox",
    // aluminum: "Alumínio",
    // rubber: "Borracha/Silicone",
    // bronze: "Bronze",
    // ceramic: "Cerâmica",
    // liquid_metal: "Cerâmica Líquida",
    // carbon: "Fibra de Carbono",
    // kevlar: "Kevlar",
    // brass: "Latão",
    // wood: "Madeira",
    // nylon: "Nylon",
    // gold: "Ouro",
    // platinum: "Platina",
    // pvd: "PVD",
    // plastic: "Resina/Plástico",
    // titanium: "Titânio",
    
}

export const caseMaterialFields: { [key: string]: string } = {
    steel: "Aço",
    bronze: "Bronze",
    yellow_gold: "Ouro Amarelo",
    rose_gold: "Ouro Rosé",
    white_gold: "Ouro Branco",
    // aluminum: "Alumínio",
    // rubber: "Borracha/Silicone",
    // ceramic: "Cerâmica",
    // liquid_metal: "Cerâmica Líquida",
    // carbon: "Fibra de Carbono",
    // fiberglass: "Fibra de Vidro",
    // brass: "Latão",
    // wood: "Madeira",
    // gold_plated: "Ouro Laminado",
    // platinum: "Platina",
    // pvd: "PVD",
    // plastic: "Resina/Plástico",
    titanium: "Titânio",
    other: "Outros"
}

export const glassFields: { [key: string]: string } = {
    crystal: "Cristal",
    acrylic: "Acrílico",
    sapphire: "Safira",
    mineral_glass: "Vidro Mineral",
    other: "Outros"
    // sapphire_crystal: "Cristal de Safira",
    // coated_sapphire_crystal: "Cristal de Safira Revestido",
    // hardlex: "Hardlex",
    // hesalite: "Hesalite",
}

export const watchFields: { [key: string]: string | number } = {
    brand: "Marca",
    model: "Modelo",
    year: "Ano",
    id: "ID",
    serial: "Serial"
}

export const functionsFields: { [key: string]: string } = {
    date: "Data",
    time: "Hora",
    stopwatch: "Cronômetro",
    compass: "Bússola",
    tide: "Indicador de Maré",
    depth: "Profundímetro",
    alarm: "Alarme",
    others: "Outros"
}

// Mensagens em pt-BR para os códigos de erro do Firebase Auth.
// Usado por getAuthErrorMessage (utils/functions.ts) nas telas de login,
// cadastro e verificação de telefone, no lugar de um "algo deu errado" genérico.
export const authErrorFields: { [key: string]: string } = {
    // login / cadastro
    "auth/invalid-credential": "E-mail ou senha incorretos.",
    "auth/wrong-password": "E-mail ou senha incorretos.",
    "auth/user-not-found": "E-mail ou senha incorretos.",
    "auth/invalid-email": "E-mail inválido. Confira o endereço digitado.",
    "auth/missing-password": "Digite sua senha.",
    "auth/user-disabled": "Esta conta foi desativada. Entre em contato com o suporte.",
    "auth/too-many-requests": "Muitas tentativas seguidas. Aguarde alguns minutos antes de tentar novamente.",
    "auth/network-request-failed": "Falha de conexão. Verifique sua internet e tente novamente.",
    "auth/email-already-in-use": "Este e-mail já está cadastrado. Faça login ou recupere sua senha.",
    "auth/weak-password": "Senha muito fraca. Use ao menos 8 caracteres, com letras e números.",
    "auth/operation-not-allowed": "Cadastro por e-mail e senha está indisponível no momento.",
    // verificação de telefone (envio do SMS)
    "auth/invalid-phone-number": "Número de telefone inválido. Confira o DDD e os 11 dígitos.",
    "auth/missing-phone-number": "Informe um número de telefone antes de continuar.",
    "auth/quota-exceeded": "Limite de envios de SMS atingido. Tente novamente mais tarde.",
    "auth/captcha-check-failed": "Falha na verificação de segurança. Recarregue a página e tente novamente.",
    // verificação de telefone (confirmação do código)
    "auth/invalid-verification-code": "Código inválido. Verifique e tente novamente.",
    "auth/missing-verification-code": "Digite o código de 6 dígitos recebido por SMS.",
    "auth/code-expired": "O código expirou. Solicite um novo código.",
    "auth/invalid-verification-id": "A sessão de verificação expirou. Solicite um novo código.",
    "auth/credential-already-in-use": "Este número já está vinculado a outra conta. Use outro número ou entre em contato com o suporte.",
    "auth/account-exists-with-different-credential": "Este número já está vinculado a outra conta. Use outro número ou entre em contato com o suporte.",
    "auth/provider-already-linked": "Esta conta já tem um telefone vinculado. Entre em contato com o suporte para trocar o número.",
}

// Rótulos pt-BR das ações registradas na coleção `adminlogs` (ver utils/adminLog.ts).
// Hoje só a gestão de usuário grava log; as demais áreas do admin ainda não.
export const adminLogActionFields: { [key: string]: string } = {
    "role.admin.grant": "Tornou admin",
    "role.admin.revoke": "Destituiu admin",
    "role.advertiser.grant": "Tornou anunciante",
    "role.advertiser.revoke": "Destituiu anunciante",
    "verify.email": "Validou e-mail manualmente",
    "verify.phone": "Validou telefone manualmente",
    "user.create": "Criou usuário",
}

// Texto exibido na tela de Logs para deixar explícito o que é (e o que ainda não é) auditado.
export const ADMIN_LOGGED_ACTIONS = [
    "Tornar / destituir admin",
    "Tornar / destituir anunciante",
    "Validar e-mail manualmente",
    "Validar telefone manualmente",
    "Criar usuário",
]
